import { render, staticRenderFns } from "./AuctionGranted.vue?vue&type=template&id=325b834e&scoped=true&"
import script from "./AuctionGranted.vue?vue&type=script&lang=ts&"
export * from "./AuctionGranted.vue?vue&type=script&lang=ts&"
import style0 from "./AuctionGranted.vue?vue&type=style&index=0&id=325b834e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325b834e",
  null
  
)

export default component.exports